import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import Box from "@mui/material/Box";
import Loading from "../../components/Loading";
import { useNotification } from "../../contexts";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import FormFooter from "../../components/FormFooter";
import { LIST_VALIDATION_SCHEMA as validationSchema } from "../../constants/validation";
import {
  PROPERTY_INITIAL_VALUES,
  UNIT_INITIAL_VALUES,
  UNIT_LEASE_INITIAL_VALUES,
  LIST_INITIAL_VALUES,
} from "../../constants/initialValues";
import { getProperty } from "../../services/properties";
import { addListing } from "../../services/listings";
import { ROUTES } from "../../constants";
import {
  getPropertyUnit,
  getPropertyUnitLeaseSettings,
} from "../../services/units";
import FormListing from "../../components/FormListing";
import ListingUnitInfos from "../../components/ListingUnitInfos";
import ListingFileUpload from "../../components/ListingFileUpload";
import { getPropertyLease } from "../../services/leases";

function AppAddListing(props) {
  const history = useHistory();
  const { id, unitid, listingId } = props.match.params;
  const { dispatch } = useNotification();
  const [isLoading, setIsLoading] = useState(true);
  const [property, setProperty] = useState();
  const [unit, setUnit] = useState();
  const [unitLeaseSettings, setUnitLeaseSettings] = useState();
  const [propertyLeaseSettings, setPropertyLeaseSettings] = useState();
  const [photoUrls, setPhotoUrls] = useState([]);
  const isPropertyManager =
    localStorage.getItem("userType") === "propertymanager" || false;

  useEffect(() => {
    const load = async () => {
      if (unitid) {
        const property1 = await getProperty(id);
        setProperty(property1);
        getPropertyUnit(id, unitid).then((data) => {
          setUnit(data);
        });
        getPropertyLease(property1.id).then((data) => {
          setPropertyLeaseSettings(data);
        });
        getPropertyUnitLeaseSettings(id, unitid).then((data) => {
          setUnitLeaseSettings(data);
        });
      } else {
        setProperty(PROPERTY_INITIAL_VALUES);
        setUnit(UNIT_INITIAL_VALUES);
        setUnitLeaseSettings(UNIT_LEASE_INITIAL_VALUES);
      }
    }
    load();
  }, [unitid]);

  useEffect(() => {
    if (unitid && unit && unitLeaseSettings) {
      setIsLoading(false);
    }
    if (!unitid) {
      setIsLoading(false);
    }
  }, [unit, unitLeaseSettings]);

  const onSubmit = (values) => {
    if (!listingId) {
      let payload = {
        propertyId: id,
        unitId: unitid,
        ...values,
        photoUrls,
        ratings: null,
      };

      if (!isPropertyManager) {
        payload = {
          ...payload,
          ratings: {
            buildingLoudness: parseInt(values.ratings.buildingLoudness),
            cleanCommonAreasInside: parseInt(
              values.ratings.cleanCommonAreasInside
            ),
            cleanWellMaintainedPropertyOutside: parseInt(
              values.ratings.cleanWellMaintainedPropertyOutside
            ),
            feltSafeInsideBuilding: parseInt(
              values.ratings.feltSafeInsideBuilding
            ),
            feltSafeOutsideBuilding: parseInt(
              values.ratings.feltSafeOutsideBuilding
            ),
            overallLivingExperience: parseInt(
              values.ratings.overallLivingExperience
            ),
            responsiveLandlord: parseInt(values.ratings.responsiveLandlord),
            waterPressure: parseInt(values.ratings.waterPressure),
          },
        };
      }

      addListing(payload).then((data) => {
        if (data.message) {
          dispatch({
            type: "add",
            notifications: [{ title: data.message, type: "error" }],
          });
        } else if (data.error) {
          dispatch({
            type: "add",
            notifications: [{ title: data.error, type: "error" }],
          });
        } else {
          dispatch({
            type: "add",
            notifications: [{ title: "Listing unit was added with success" }],
          });
        }
        history.push(ROUTES.PRIVATE_LISTINGS);
      });
    }
  };

  const onChangeFile = (setFieldValue) => (photoUrls) => {
    setFieldValue("photoUrls", photoUrls);
    setPhotoUrls(photoUrls);
  };

  return (
    <Layout isLoading={isLoading}>
      <PageHeader title={`Listing Unit ${unit?.number}`} />
      <Box sx={{ gridArea: "main" }}>
        <ListingUnitInfos
          property={property}
          unit={unit}
          propertyLeaseSettings={propertyLeaseSettings}
          unitLeaseSettings={unitLeaseSettings}
        />
        <Formik
          initialValues={LIST_INITIAL_VALUES}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, setFieldValue }) => (
            <form onSubmit={handleSubmit}>
              <ListingFileUpload
                photoUrls={photoUrls}
                onChange={onChangeFile(setFieldValue)}
              />
              {!isPropertyManager && <FormListing />}
              <FormFooter onCancel={() => history.push(`/property/${id}`)} />
            </form>
          )}
        </Formik>
      </Box>
    </Layout>
  );
}

export default AppAddListing;
